<section>
	<div class="row" *ngFor="let model of models; let i = index">
		<div class="col-18 col-md-16 cell">
			<!-- Checkbox with model name for ST -->
			<label class="ac-input ac-checkbox" *ngIf="showCheckboxes && allowMultiple" [ngClass]="{ 'disabled-label': isRowDisabled(model) }">
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<dz-checkbox type="checkbox" [disabled]="isRowDisabled(model)" [checked]="isModelSelected(model)" (change)="onModelSelectionClick($event, model)">
					<span class="title text-16">{{ getModelName(model) }}</span>
				</dz-checkbox>
			</label>
			<dz-radio *ngIf="showCheckboxes && !allowMultiple" [checked]="isModelSelected(model)" (click)="onModelSelectionClick($event, model)">
				{{ getModelName(model) }}
			</dz-radio>
			<!-- Model name for 360 -->
			<span *ngIf="!showCheckboxes" class="title text-16">{{ getModelName(model) }}</span>
		</div>

		<div class="col-6 col-md-8 cell">
			<!-- Buttons for 360 -->
			<div *ngIf="!showCheckboxes" class="buttons text-align-right">
				<!-- View 360 Analysis -->
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<button
					*ngIf="tableMode !== 'COMPARE' && tableMode !== 'REPLACE'"
					dz-button
					(click)="closeModal(model.id)"
					custom-event-type="find-a-model-complete"
					dcrHTMLKey="BTN_DETAILS"
					[disabled]="isView360AnalysisDisabled(model)"
					custom-tracking
					[track-event]="'view 360 analysis event:' + model.subType + ':' + model.id"
				>
					View 360&deg; Analysis
				</button>
				<!-- Add To Comparison -->
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<button
					*ngIf="tableMode === 'COMPARE'"
					dz-button
					class="compare-button"
					(click)="addToComparison(model)"
					[disabled]="existsInSelectedModelIdsFromUrl(model)"
					custom-tracking
					[track-event]="'add to comparison event:' + model.subType + ':' + model.id"
				>
					<span class="icon-caption" dcrHTMLKey="ADD_TO_COMPARISON">Add To Comparison</span>
				</button>
				<!-- Choose Replacement -->
				<button dz-button *ngIf="tableMode === 'REPLACE'" (click)="chooseReplacement(model)" [disabled]="existsInSelectedModelIdsFromUrl(model)">
					<span class="icon-caption" dcrHTMLKey="CHOOSE_REPLACEMENT">Choose Replacement</span>
				</button>
			</div>
		</div>
	</div>
</section>
